<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import CheckMore from '../common/CheckMore.vue'

import { getPageThemeColor, getModule7ImgBg, getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp7',
  components: { ModuleTitle, CheckMore },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      admini: localStorage.getItem('admini')
    }
  },
  methods: {
    getPageThemeColor, getModule7ImgBg, getShadowColor,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    },
    templateNameFilter(title) {
      let titleStr = ''
      switch (title) {
        case '社区救助类': titleStr = this.admini === '社区' ? '社区救助类' : '村救助类'
          break
        default: titleStr = title
      }
      return titleStr
    }
  }
}
</script>

<template>
  <div class="modules-id-7">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div v-if="moduleOption.list.length > 0" class="comp-transverse-3 modules-id-7-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 5)"
        :key="`modules-7-${v.titleid}`"
        class="item"
        :style="{
          background: `url(${getModule7ImgBg(path)}) no-repeat center`,
          backgroundSize: '100% 100%',
          boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`
        }"
        @click="onModuleItem(v)"
      >
        <p class="item-title h-line-2">
          {{ `${i+1}. ${templateNameFilter(v.headline) || ''}` }}
        </p>
      </div>
      <check-more mode="1" />
    </div>
    <el-skeleton v-else animated />
  </div>
</template>

<style lang="scss" scoped>
.modules-id-7-content {
  display: flex;
  flex-wrap: wrap;
  column-gap: 23px;
  row-gap: 30px;
  height: 100%;
  .item {
    width: 216px;
    height: 94px;
    border-radius: 5px;
    display: grid;
    place-items: center;
    .item-title {
      width: 80%;
      font-size: 17px;
      font-weight: bold;
      color: #000;
      text-align: center;
    }
  }
}
</style>
